var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("RouteBreadcrumb", {
        attrs: { routes: _vm.rutas, "ends-file": true },
      }),
      _vm._v(" "),
      _c("acciones", {
        on: {
          descargar: _vm.descargar,
          recargar: _vm.updateDocument,
          deleteDocument: _vm.openDeleteDocument,
          renameDocument: _vm.openRenameDocument,
          moveDocument: _vm.openMoveDocument,
          addpila: _vm.addToPila,
          preview: _vm.openMoveDocument,
          "side-by-side": _vm.toggleSideBySide,
          print: _vm.printFile,
        },
      }),
      _vm._v(" "),
      _c("section", { staticClass: "section" }, [
        _c("div", {}, [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c(
                      "h1",
                      { staticClass: "title document-title is-3 is-size-4" },
                      [
                        _c("i", { staticClass: "far fa-file" }),
                        _vm._v(
                          "  " +
                            _vm._s(
                              _vm.documento.nombre.length > 50
                                ? _vm.documento.nombre.substring(0, 50) + "..."
                                : _vm.documento.nombre
                            )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("informacion", {
                      attrs: {
                        "can-asignar-aspectos":
                          _vm.$store.getters.hasAnyRole([
                            "aspec-user",
                            "lyris",
                          ]) && _vm.nivelPermisoUser >= 6,
                        "can-delete-aspectos":
                          _vm.$store.getters.hasAnyRole([
                            "aspec-user",
                            "lyris",
                          ]) && _vm.nivelPermisoUser >= 6,
                      },
                      on: {
                        "open-asignar-aspecto": _vm.openAsignarAspecto,
                        "quitar-aspecto": _vm.quitarAspecto,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._l(_vm.aspectosDocumento, function (aspecto) {
                      return _c("metadatos", {
                        key: `asp-meta-${aspecto.id}`,
                        attrs: {
                          "force-edit": false,
                          "hide-save-button": false,
                          metadatos: _vm.documento.lista_metadatos,
                          aspecto: aspecto,
                          "read-only": _vm.nivelPermisoUser < 4,
                          "can-edit":
                            _vm.$store.getters.hasAnyRole([
                              "aspec-user",
                              "lyris",
                            ]) && _vm.nivelPermisoUser >= 4,
                        },
                        on: { submit: _vm.saveEditMetadatos },
                      })
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box" },
                  [_vm._m(1), _vm._v(" "), _c("firmas")],
                  1
                ),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("permisos", {
                  attrs: {
                    documento: _vm.documento,
                    "nivel-permiso-user": _vm.nivelPermisoUser,
                  },
                  on: { updateDocument: _vm.updateDocument },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.openSideBySide
              ? _c(
                  "div",
                  { staticClass: "column is-3" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "box is-paddingless box-preview-document",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "overlay-button-side-by-side button is-primary is-radiusless p-2 is-hidden-touch",
                            on: { click: _vm.toggleSideBySide },
                          },
                          [_c("i", { staticClass: "fas fa-columns" })]
                        ),
                        _vm._v(" "),
                        _c("figure", { staticClass: "image" }, [
                          _vm.documento.preview_uri
                            ? _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.previewModalActive = true
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.documento.preview_uri,
                                      alt: "Previsualización",
                                    },
                                  }),
                                ]
                              )
                            : _c("img", {
                                attrs: {
                                  src: "/statics/default-document.png",
                                  alt: "Previsualización",
                                },
                              }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isVersionable
                      ? _c("subir-version", {
                          attrs: { "documento-id": _vm.documento.id },
                          on: { updateDocument: _vm.updateDocument },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _c("div", { staticClass: "column is-6 pl-0" }, [
                  _c("div", { staticClass: "is-flex file-side-to-side" }, [
                    _c(
                      "a",
                      { on: { click: _vm.toggleSideBySide } },
                      [
                        _c(
                          "b-tooltip",
                          { attrs: { label: "Cerrar", position: "is-left" } },
                          [
                            _c("i", {
                              staticClass: "fas fa-lg fa-angle-double-right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("iframe", {
                      attrs: { src: _vm.urlPreviewer, frameborder: "0" },
                    }),
                  ]),
                ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.previewModalActive },
          on: {
            "update:active": function ($event) {
              _vm.previewModalActive = $event
            },
          },
        },
        [
          _c("figure", { staticClass: "image" }, [
            _c("img", {
              attrs: {
                src: _vm.documento.preview_uri,
                alt: "Previsualización",
              },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _vm._v(" Metadatos"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
      _c("i", { staticClass: "fas fa-signature" }),
      _vm._v(" Firmas"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box mb-0" }, [
      _c("h1", { staticClass: "subtitle is-5 has-text-primary" }, [
        _c("i", { staticClass: "fas fa-users-cog" }),
        _vm._v(" Permisos"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }